var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup-block',{attrs:{"closeModal":_vm.closeModal,"green_header":!_vm.info_icon,"green_header_info":_vm.info_icon,"shown":_vm.opened}},[_c('div',{staticClass:"default-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"mt-20",domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }